import React, { useEffect, useState } from "react";
import { btns } from "../Data";
import { photoshoots } from "../Data";
import { motion, AnimatePresence } from "framer-motion";
import { fadeIn } from "../Transitions";

const Photography = () => {
  const [filterImages, setFilterImages] = useState(null);
  useEffect(() => {
    setFilterImages(photoshoots);
  }, []);

  const handleClick = (e) => {
    let btnType = e.target.value;
    const newFilterImages = photoshoots.filter(
      (photoshoot) => photoshoot.value === btnType
    );
    btnType !== "all"
      ? setFilterImages(newFilterImages)
      : setFilterImages(photoshoots);
  };

  return (
    <div className="section1" id="photography">
      <div className="mb-8">
        <motion.h2
          variants={fadeIn("left", 0.3)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.3 }}
          className="text-[1.5rem] font-bold"
        >
          {" "}
          Photography
        </motion.h2>
        <motion.div
          variants={fadeIn("left", 0.3)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.3 }}
          className="w-14 h-[3px] rounded-sm bg-gradient-to-r from-gray-200 via-gray-400 to-gray-600"
        ></motion.div>
      </div>
      <motion.div
        variants={fadeIn("right", 0.3)}
        initial="hidden"
        whileInView={"show"}
        viewport={{ once: false, amount: 0.3 }}
        className="px-8 flex flex-wrap gap-8"
      >
        {btns.map((btn) => {
          return (
            <button key={btn.id} value={btn.value} onClick={handleClick}>
              {btn.name}
            </button>
          );
        })}
      </motion.div>

      <AnimatePresence>
        <motion.div className="grid sm:grid-cols-2 md:grid-cols-3 mt-12 gap-2">
          {filterImages &&
            filterImages.map((filterImage) => {
              return (
                <motion.div
                  layout
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0, transition: { duration: 0.3 } }}
                  key={filterImage.id}
                >
                  <motion.img src={filterImage.image} alt="" />
                </motion.div>
              );
            })}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Photography;
